import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";

import Footer from "components/Footer/Footer.jsx";
import PagesHeader from "components/Header/PagesHeader.jsx";

class NotRole extends Component {

  render() {
    return (
      <div>
        <PagesHeader />
        <div className="wrapper wrapper-full-page">
          <div
            className={"full-page"}
            data-color="black"
          >
            <div className="content" style={{color: "white"}}>
              Estás haciendo trampa, no puedes acceder a esto. async
              {"< Regresar"}
            </div>
            <Footer transparent />
            <div
              className="full-page-background"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default NotRole;



// WEBPACK FOOTER //
// ./src/layouts/notRole.js